export default {"src":"/_next/static/media/warning-icon.d01c34be.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};